module.exports = __webpack_public_path__ + "img/brand-20.4e55accf.png";